import { BaseApi } from './apiBase';

interface TagSearchParams {
  teamSubdomain: string;
  query?: string;
  context?: 'seeking' | 'providing';
}

export interface TagSearchResult {
  id: string;
  name: string;
  displayName: string;
  context?: string;
}

class TagsApi extends BaseApi {
  async searchTags(params: TagSearchParams): Promise<TagSearchResult[]> {
    try {
      const searchParams = {
        teamSubdomain: params.teamSubdomain,
        q: params.query || ''
      };

      return await this.get<TagSearchResult[]>('/tags/search', searchParams);
    } catch (error) {
      console.error('Error searching tags:', error);
      return [];
    }
  }
}

export const tagsApi = new TagsApi();